module.exports = __webpack_public_path__ + "img/badge_cond_privacy.155ad123.jpg";